import { errorLogger } from "@Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

export async function getAuthorizationActions(locationId, scope = []) {
	const query = gql`
		query getAuthorizationActions($locationId: String!, $filter: AuthFilter) {
			getAuthorizationActions(locationId: $locationId, filter: $filter) {
				_id
				actionKey
				actionName
				actionDescription
				category
			}
		}
	`;

	const variables = {
		locationId,
		filter: {
			scope,
		},
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getAuthorizationActions;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export async function getAuthorizationGroups(locationId) {
	const query = gql`
		query getAuthorizationGroups($locationId: String!) {
			getAuthorizationGroups(locationId: $locationId) {
				_id
				locationId
				groupName
				groupDescription
				groupActions
			}
		}
	`;

	const variables = {
		locationId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getAuthorizationGroups;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}
